import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';

export const ListProposals = ({
  idCustomer,
  proposalsAssociates,
  handleGenerateReport,
}) => {
  return (
    <div className="table-responsive">
      <Table className="align-middle table-nowrap mb-0">
        <thead>
          <tr>
            <th scope="col">Número</th>
            <th scope="col">Categoria</th>
            <th scope="col">Plano</th>
            <th scope="col">Mensalidade</th>
            <th scope="col">Validade</th>
            <th scope="col">Situação</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {(proposalsAssociates ? proposalsAssociates.data : []).map((item) => (
            <tr key={item.id}>
              <th scope="row">{item.number}</th>
              <td>{item.category}</td>
              <td>{item.plan}</td>
              <td>{item.price}</td>
              <td>{item.valid_until}</td>
              <td>
                <span
                  className={`badge badge-soft-${item.status_color} badge-border`}
                >
                  {item.status}
                </span>
              </td>
              <td>
                <Link
                  to={'#'}
                  onClick={() => handleGenerateReport(item.id)}
                  className="link-success"
                >
                  Imprimir envelope{' '}
                  <i className="ri-arrow-right-line align-middle"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {proposalsAssociates && proposalsAssociates.data.length <= 0 && (
        <div className="d-flex justify-content-center">
          <div>
            <div className="d-flex justify-content-center mb-1">
              <h6 className="text-center mt-4">Sem propostas cadastradas</h6>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
